import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (companyId, draftId, data) => {
	const headers = { 'content-type': 'application/json' };
	const url = EndPoints.COMPANY_DRAFT.replace(':companyId', companyId).replace(':draftId', draftId);
	return fetch(Methods.POST, url, data, headers, true);
};
